<div class="ion-padding aksz">
  <h2><ion-icon name="shield-checkmark-outline"></ion-icon> Adatkezelési szabályzat</h2>

  <p class="aksz-halvany">
    Az intézmény adatkezelési szabályzatát a tanulmányi rendszeren át is hozzáférhetővé kell tenni. Amit itt
    feltöltesz (PDF), az azonnal megjelenik a <a routerLink="/adatkezeles" [queryParams]="{ intezmeny: intezmeny }">nyilvános
    adatkezelési oldalon</a>: belépés nélkül is olvasható, és a belépő oldal aljáról, a családi belépés képernyőjéről
    és a menü aljáról is elérhető.
  </p>

  <ion-note color="danger" class="aksz-hiba" *ngIf="hiba">{{ hiba }}</ion-note>
  <div class="aksz-halvany" *ngIf="fut && !helyek.length">Betöltés…</div>

  <div class="aksz-kartya" *ngFor="let h of helyek">
    <div class="aksz-kartya-fej">
      <h3>{{ h.tipus_nev }}</h3>
      <span class="aksz-allapot" [class.van]="h.dokumentum">{{ h.dokumentum ? 'Közzétéve' : 'Nincs feltöltve' }}</span>
    </div>

    <div *ngIf="h.dokumentum" class="aksz-meglevo">
      <a [href]="h.dokumentum.url" target="_blank" rel="noopener">{{ h.dokumentum.cim }}</a>
      <span class="aksz-halvany">
        – {{ h.dokumentum.fajlnev }}, feltöltve: {{ datum(h.dokumentum.feltoltve) }}<span *ngIf="h.dokumentum.feltoltotte">
        ({{ h.dokumentum.feltoltotte }})</span><span *ngIf="h.dokumentum.hatalyos_tol">, hatályos: {{ datum(h.dokumentum.hatalyos_tol) }}</span>
      </span>
      <ion-button size="small" fill="clear" color="danger" (click)="torol(h)" [disabled]="ment === h.tipus">
        <ion-icon slot="start" name="trash-outline"></ion-icon>Törlés
      </ion-button>
    </div>

    <form class="aksz-urlap" *ngIf="urlapok[h.tipus] as u" (ngSubmit)="feltolt(h)">
      <label>Cím a nyilvános oldalon
        <input type="text" [name]="'cim-' + h.tipus" [(ngModel)]="u.cim" maxlength="255">
      </label>
      <label>Hatályos (nem kötelező)
        <input type="date" [name]="'hatalyos-' + h.tipus" [(ngModel)]="u.hatalyos_tol">
      </label>
      <label>PDF-fájl
        <input type="file" accept="application/pdf,.pdf" (change)="fajlValaszt(h.tipus, $event)">
      </label>
      <ion-button size="small" type="submit" [disabled]="ment === h.tipus || !u.fajl">
        <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>{{ h.dokumentum ? 'Csere' : 'Feltöltés' }}
      </ion-button>
    </form>
  </div>

  <p class="aksz-halvany aksz-kicsi">
    Csak PDF, legfeljebb 20 MB. Az új feltöltés a régit váltja (a régi fájl törlődik). A dokumentum nyilvános irat –
    személyes adatot (pl. aláírt példány nevekkel) ne tölts fel.
  </p>
</div>
